import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import clsx from 'clsx';
import Infobox from 'components/player/shared/infobox/component';
import Playersbar from '../../../player/dashboard/playersbar/component';
import Sidebar from 'components/shared/sidebar/component';
import PlayersSidebar from 'components/player/shared/players-sidebar/component';
import { SIDEBAR_MODE_PLAYER } from 'components/constants';
import { hasGameEnded, isGameLocked } from 'helpers/gameUtilities';
import { setT } from 'helpers/translationUtilities';
export default function ViewDashboard() {
    var navigate = useNavigate();
    var rawCompany = useSelector(function (state) { return state.player.company; });
    var company = useMemo(function () { return ({
        id: rawCompany.id,
        name: rawCompany.name,
        totalBalance: rawCompany.totalBalance,
        transactions: rawCompany.transactions,
        description: rawCompany.description
    }); }, [rawCompany]);
    var game = useSelector(function (state) { return state.game; });
    var players = useSelector(function (state) { return state.general.players; });
    var rawPlayer = useSelector(function (state) { return state.player; });
    var player = useMemo(function () { return ({
        id: rawPlayer.id,
        name: rawPlayer.name,
        totalBalance: rawPlayer.totalBalance,
        company: rawPlayer.company
    }); }, [rawPlayer]);
    var stages = useSelector(function (state) { return state.game.stages; });
    var tasks = useSelector(function (state) { return state.player.tasks.items; });
    var managePlayersDisabled = isGameLocked(stages) || hasGameEnded(stages);
    var _a = getDashboardTaskCounts(tasks, player), playerTasks = _a.playerTasks, companyTasks = _a.companyTasks;
    var companyPlayers = players.filter(function (p) { return p.companyID === company.id; });
    function redirectToOnboardingPlayers(id) {
        navigate("/onboarding/players/".concat(id));
    }
    return (React.createElement("div", { className: "playerdashboard playerdashboard--with-players-sidebar" },
        React.createElement(Sidebar, { type: SIDEBAR_MODE_PLAYER }),
        React.createElement(PlayersSidebar, null),
        React.createElement("div", { className: "topheader" },
            React.createElement("div", { className: "topheader__primary" },
                setT('welcome_back'),
                ", ",
                player.name,
                "!"),
            React.createElement("div", { className: "topheader__secondary" },
                setT('game_code'),
                ": ",
                game.token)),
        React.createElement("div", { className: "dashboard" },
            React.createElement("div", { className: "f-grid flex-wrap flex-no-wrap-lg" },
                React.createElement("div", { className: "f-grid-col-12 f-grid-col-lg-8 infoboxes flex-wrap flex-no-wrap-sm" },
                    React.createElement("div", { className: "f-grid flex-wrap flex-no-wrap-sm" },
                        React.createElement("div", { className: "f-grid-col-12 f-grid-col-sm-6" },
                            React.createElement(Infobox, { title: setT('tasks_assigned'), icon: 'task_colored', className: 'infobox__wrapper--primary', columns: [
                                    { label: setT('personal'), value: playerTasks.length, className: 'infobox__column--lg' },
                                    { label: setT('business'), value: companyTasks.length, className: 'infobox__column--lg' }
                                ] })),
                        React.createElement("div", { className: "f-grid-col-12 f-grid-col-sm-6 mar-grid-space-top mar-top-0-sm" },
                            React.createElement(Infobox, { title: setT('account_balance'), icon: 'account_colored', className: 'infobox__wrapper--primary', columns: [
                                    { label: setT('personal'), value: "".concat(player.totalBalance), className: 'infobox__column--lg' },
                                    { label: setT('business'), value: "".concat(company.totalBalance), className: 'infobox__column--lg' }
                                ] }))),
                    React.createElement("div", { className: "custom-content-area mar-top-15", dangerouslySetInnerHTML: { __html: company.description } })),
                React.createElement("div", { className: "f-grid-col-12 f-grid-col-lg-4 mar-grid-space-top mar-top-0-lg" },
                    React.createElement("div", { className: "dashboard__sidebar" },
                        React.createElement(Infobox, { title: setT('employees'), className: 'infobox__wrapper--primary', icon: 'person', headerRender: function () { return (React.createElement("button", { className: clsx(['main-button main-button--lg', managePlayersDisabled && 'main-button--disabled']), onClick: function () { return !managePlayersDisabled && redirectToOnboardingPlayers(company.id); } }, setT('manage'))); } },
                            React.createElement(Playersbar, { players: companyPlayers }))))))));
}
function getDashboardTaskCounts(tasks, player) {
    return {
        playerTasks: tasks.filter(function (task) { return task.to === player.id; }),
        companyTasks: tasks.filter(function (task) { return task.to === player.company.id; })
    };
}
